import { isNumber } from 'lodash';
import { CreateElement } from 'vue';
import {Vue,Component} from 'vue-property-decorator';
import Base from './module/Base';
import { defaultRow } from './module/inputUtility';
import SubmitLoader from './sub/SubmitLoaderBox';

@Component
export default class FromManual extends Base {


    public isManual:boolean = true;


    created() {

        this.fetchSetting();
        this.fetchCategories();
        this.fetchUnits();
        this.fetchWarehouses();
        this.fetchVendors();
        this.fetchCosLedgers();
        this.fetchVariants();

        this.rows = [defaultRow([])]
        this.count = 1;
    }


    render(h:CreateElement){
        return h('div',{staticClass:'bulkStock',class:{
            has:this.count
        }},[
          

            this.TableFields(h),

            h(SubmitLoader,{
                props:{
                    busy:this.busy,
                    successCount:this.successCount,
                    errorCount:this.errorCount
                }
            })
        ])
    }


}